import { render } from "./FormLayout.vue?vue&type=template&id=4b40ec45"
import script from "./FormLayout.vue?vue&type=script&lang=js"
export * from "./FormLayout.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1189531127/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__